export interface ReportFieldConfig {
  name: string;               // formControlName
  label: string;              // label in UI
  type?: 'text' | 'date' | 'select' | 'search'; // field type
  required?: boolean;
  position: number;
  showIf?: { field: string; value: any };           // order
}



export const REPORT_FORMS: Record<string, ReportFieldConfig[]> = {
  'action-status-on-cases': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'action-status-on-appeals': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'case-duration': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'case-hearing-schedule': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'caseCategory', label: 'Case Category', type: 'select', required: true, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'appeal-hearing-schedule': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'case-history': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'appeal-history': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'case-history-for-counsel': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'counselName', label: 'Counsel Name', type: 'select', required: true, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'appeal-history-for-counsel': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'counselName', label: 'Counsel Name', type: 'select', required: true, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'case-assignment-statistics': [
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 1 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 2 },
  ],
  'current-phase-of-cases': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'current-phase-of-appeals': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'case-progress': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'caseNumber', label: 'Case/Appeal Number', type: 'search', required: true, position: 2 },
  ],
  'cases-pending-for-hearing': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'appeals-pending-for-hearing': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'causelist': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'caseCategory', label: 'Case Category', type: 'select', required: true, position: 2 },
    { name: 'reportType', label: 'Report Type', type: 'select', required: true, position: 3 },
    {
      name: 'fromDate',
      label: 'From Date',
      type: 'date',
      required: true,
      position: 4,
      showIf: { field: 'reportType', value: 'DATERANGE' }
    },
    {
      name: 'tillDate',
      label: 'To Date',
      type: 'date',
      required: true,
      position: 5,
      showIf: { field: 'reportType', value: 'DATERANGE' }
    },
    {
      name: 'fromDate',
      label: 'Date',
      type: 'date',
      required: true,
      position: 6,
      showIf: {
        field: 'reportType',
        value: 'DAILY'
      }
    },

  ],
  'date-alert-by-last-document-recorded': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'tillDate', label: 'Till Date', type: 'date', required: true, position: 2 },
    { name: 'caseCategory', label: 'Case Category', type: 'select', required: true, position: 3 },
  ],
  'pending-tasks-till-date': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'caseCategory', label: 'Case Category', type: 'select', required: true, position: 2 },
    { name: 'roleName', label: 'Role Name', type: 'select', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'documents-received-for-case': [
    { name: 'caseNumber', label: 'Case/Appeal Number', type: 'search', required: true, position: 1 },
  ],
  'documents-received-for-appeal': [
    { name: 'caseNumber', label: 'Appeal Number', type: 'search', required: true, position: 1 },
  ],
  'judge-panel-for-appeals': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'caseNumber', label: 'Appeal Number', type: 'search', required: false, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'list-of-cases-by-judge': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'judge', label: 'Judge', type: 'select', required: true, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'list-of-appeals-by-justice': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'judge', label: 'Justice', type: 'select', required: true, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'list-of-cases-handled-by-judge': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'judge', label: 'Judge', type: 'select', required: true, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'list-of-appeals-handled-by-justice': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'judge', label: 'Justice', type: 'select', required: true, position: 2 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 3 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 4 },
  ],
  'list-of-cases-received': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'list-of-appeals-received': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'list-of-judges-that-handled-case': [
    { name: 'caseNumber', label: 'Case/Appeal Number', type: 'search', required: true, position: 1 },
  ],
  'list-of-justices-that-handled-appeal': [
    { name: 'caseNumber', label: 'Appeal Number', type: 'search', required: true, position: 1 },
  ],
  'case-statistics': [
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 1 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 2 },
    { name: 'partyName', label: 'Party Name', type: 'search', required: false, position: 3 },
    { name: 'filedOn', label: 'Filed On', type: 'date', required: false, position: 4 },
    { name: 'caseStatus', label: 'Case Status', type: 'select', required: false, position: 5 },
    { name: 'casePhase', label: 'Case Phase', type: 'select', required: false, position: 6 },
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: false, position: 7 },
    { name: 'caseTypes', label: 'Case Types', type: 'select', required: false, position: 8 },
    { name: 'courts', label: 'Courts', type: 'select', required: false, position: 9 },
  ],
  'appeal-statistics': [
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 1 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 2 },
    { name: 'partyName', label: 'Party Name', type: 'search', required: false, position: 3 },
    { name: 'filedOn', label: 'Filed On', type: 'date', required: false, position: 4 },
    { name: 'caseStatus', label: 'Appeal Status', type: 'select', required: false, position: 5 },
    { name: 'casePhase', label: 'Appeal Phase', type: 'select', required: false, position: 6 },
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: false, position: 7 },
    { name: 'caseTypes', label: 'Appeal Types', type: 'select', required: false, position: 8 },
  ],
  'list-of-motions-filed-in-case': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'caseNumber', label: 'Case/Appeal Number', type: 'search', required: true, position: 2 },
  ],
  'staff-assignment-history': [
    { name: 'courtDivision', label: 'Division', type: 'select', required: true, position: 1 },
    { name: 'roleName', label: 'Staff Role', type: 'select', required: true, position: 2 },
    { name: 'staffName', label: 'Staff Name', type: 'select', required: true, position: 3 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 4 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 5 },
  ],
  'list-of-users-and-roles': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'list-of-backlog-cases': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'list-of-backlog-appeals': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'list-of-appeals-by-status': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'caseStatus', label: 'Case Status', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'audit-trail': [
    { name: 'partyName1', label: 'Party Name', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'pending-case-statistics': [
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 1 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 2 },
    { name: 'partyName', label: 'Party Name', type: 'select', required: false, position: 3 },
    { name: 'caseTypes', label: 'Case Types', type: 'select', required: false, position: 4 },
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 5 },
    { name: 'courts', label: 'Courts', type: 'select', required: false, position: 6 },
  ],
  'appeal-summary-based-on-appeal-type': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'appeals-by-lower-court': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'fromDate', label: 'From Date', type: 'date', required: true, position: 2 },
    { name: 'tillDate', label: 'To Date', type: 'date', required: true, position: 3 },
  ],
  'appeals-by-party-name': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'partyName2', label: 'Party Name', type: 'select', required: true, position: 2 },

  ],
  'appeal-details-based-on-party-name': [
    { name: 'courtDivision', label: 'Court Division', type: 'select', required: true, position: 1 },
    { name: 'partyName2', label: 'Party Name', type: 'select', required: true, position: 2 },
  ]

};
